export enum TranslationLanguage {
  EN = 'en',
  SV = 'sv',
  NO = 'no',
  Development = 'development',
}
